// extracted by mini-css-extract-plugin
module.exports = {"testimonialsContainer":"styles-module--testimonialsContainer--VU26r","quoteStyles":"styles-module--quoteStyles--39O6h"};